import { isInMacWebview, isInWinWebview, pushDebugInfo } from '@/libs/utils'

/**
 * 和webview进行交互，获取客户端数据或调用客户端方法
 * @param {String} actionName 操作名
 * @param {Object} params 参数对象
 * @returns {Primise}
 */
export const webviewAction = (actionName, params = null) => {
  let paramsStr = ''
  if (params && Object.keys(params).length > 0) {
    paramsStr =
      '?' +
      Object.keys(params)
        .map(key => `${key}=${params[key]}`)
        .join('&')
  }
  return new Promise((resolve, reject) => {
    if (isInWinWebview()) {
      const query = {
        request: `${actionName}${paramsStr}`,
        onSuccess: res => {
          resolve(res)
          pushDebugInfo(res)
        },
        onFailure: res => {
          reject(res)
          pushDebugInfo(res)
        },
      }
      pushDebugInfo(query)
      window.QCefQuery(query)
    } else if (isInMacWebview()) {
      resolve('[]')
    } else {
      resolve('[]')
    }
  })
}

/**
 * 获取客户端已登录账号列表
 * @returns {Promise}
 */
export const getLoggedAccounts = () => {
  return webviewAction('getLoginedAccounts')
}
